import React from "react";
import { Route, Switch } from "react-router-dom";
import {
  MemberForgotPassword,
  MemberLogin,
  MemberRegister,
} from "views/Member/MemberPages";
import NotFoundPage from "views/NotFoundPage";

export default function MemberAuth() {
  return (
    <div className="member-auth-shell">
      <div className="member-auth-visual">
        <img src={require("assets/img/pugar.png").default} alt="PUGAR" />
        <h2>Portal Anggota PUGAR</h2>
        <p>Flow web untuk anggota mengikuti fungsi yang tersedia di aplikasi mobile.</p>
      </div>
      <Switch>
        <Route exact path="/member/auth/login" component={MemberLogin} />
        <Route exact path="/member/auth/register" component={MemberRegister} />
        <Route exact path="/member/auth/forgot-password" component={MemberForgotPassword} />
        <Route render={() => <NotFoundPage variant="auth" />} />
      </Switch>
    </div>
  );
}
